import React from 'react';
import {Link} from 'react-router-dom';
import {Transitioner, Button} from 'components';

import AcceptInviteWhoAreWe from './AcceptInvite.WhoAreWe';

interface IAcceptInviteAccountNeededProps {
  invitor: string;
}

const AcceptInviteAccountNeeded = ({invitor}: IAcceptInviteAccountNeededProps) => {
  return (
    <section className="flex flex-col flex-1 p-6 lg:px-8">
      <Transitioner>
        <div className="sm:mx-auto sm:w-full sm:max-w-2xl">
          <h1 className="text-center text-2xl/9 font-bold dark:text-white">Join DasAR to start working on project(s)</h1>
          <p className="text-center dark:text-white mt-5">
            You were invited by <strong>{invitor}</strong>.
          </p>
        </div>
        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm flex flex-col items-center mb-10">
          <p className="text-sm dark:text-darkText pb-3">You need an account to continue</p>
          <Link to="/sign-up">
            <Button text="Create account" fullWidth size="small" />
          </Link>
        </div>
        <div className="flex justify-center py-10">
          <Transitioner delay={0.1}>
            <AcceptInviteWhoAreWe />
          </Transitioner>
        </div>
      </Transitioner>
    </section>
  );
};

export default React.memo(AcceptInviteAccountNeeded);
